import React from 'react';
import { benefits } from '../data/modules';
import { CTAButton } from './CTAButton';
export function BenefitsSection() {
  return <section className="border-y border-sage/30 bg-cream-dark px-4 py-8" data-id="element-17" data-mp="bpb4i9bt6pk">
      <div className="mx-auto max-w-4xl" data-id="element-18" data-mp="3iqzvd8zcmlzy">
        <h2 className="text-center font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-19" data-mp="3io3ylnz8m3d3">
          Cosa cambierà da oggi
        </h2>

        <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-20" data-mp="38rr4iozs5nht">
          {benefits.map(benefit => <article key={benefit.title} className="h-full rounded-xl border border-sage/40 bg-white p-4" data-id="element-21" data-mp="3drdij0nfn7ro">
              <h3 className="font-display text-base font-extrabold leading-tight sm:text-lg" data-id="element-22" data-mp="2ztf7a44errge">
                {benefit.title}
              </h3>
              <div className="mt-1.5 space-y-0.5 text-[13px] leading-snug text-graphite sm:text-sm" data-id="element-23" data-mp="xzft9azwiw00">
                {benefit.lines.map(line => <p key={line} data-id="element-24" data-mp="12yam75rl20xu">{line}</p>)}
              </div>
            </article>)}
        </div>

        <CTAButton className="mx-auto mt-5 max-w-lg" data-id="element-25" data-mp="27dkc6o118bjn" />
      </div>
    </section>;
}